import { Link, useLocation } from 'react-router-dom';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@emotion/react';

import codemeta from '../../assets/codemeta.svg';
import logo from '../../assets/logo.svg';

export default function Footer() {
  const theme = useTheme();
  const { pathname } = useLocation();

  return (
    <Box
      sx={{
        py: '64px',
        width: '65%',
        display: 'flex',
        minWidth: `${theme.breakpoints.values.md - 50}px`,
        maxWidth: '1800px',
        alignItems: 'flex-start',
        [theme.breakpoints.down('md')]: {
          flexDirection: 'column',
          textAlign: 'center',
        },
      }}
    >
      <Box
        sx={{
          width: '35%',
          minWidth: '240px',
          [theme.breakpoints.down('md')]: {
            width: '100%',
          },
        }}
      >
        <Link to="/" onClick={() => scrollTo(0, 0)}>
          <Box
            sx={{
              mb: '22px',
              display: 'flex',
              alignItems: 'center',
              [theme.breakpoints.down('md')]: {
                justifyContent: 'center',
              },
            }}
          >
            <img
              src={logo}
              style={{
                height: '32px',
              }}
              alt="Codemeta Logo"
            />

            <img
              src={codemeta}
              style={{
                height: '22px',
                marginLeft: '5px',
              }}
              alt="Codemeta"
            />
          </Box>
        </Link>

        <Typography sx={{ lineHeight: '20px' }}>
          Codemeta GmbH
          <br />
          Daimlerstr. 22a
          <br />
          54634 Bitburg
        </Typography>
      </Box>

      <Box
        sx={{
          width: '35%',
          minWidth: '240px',
          [theme.breakpoints.down('md')]: {
            mt: '20px',
            width: '100%',
          },
        }}
      >
        <Typography
          variant="h6"
          sx={{
            mb: '8px',
            fontWeight: 'bold',
            fontSize: '20px',
          }}
        >
          Kontakt
        </Typography>

        <Box sx={{ lineHeight: '20px' }}>
          <Box sx={{ lineHeight: '20px' }}>
            Telefon:{' '}
            <Typography
              component="a"
              href="tel:+4965616994420"
              sx={{ color: 'link.main' }}
            >
              +49 6561 6994420
            </Typography>
            <br />
            E-Mail:{' '}
            <Typography
              component="a"
              href="mailto:info@codemeta.de"
              sx={{ color: 'link.main' }}
            >
              info@codemeta.de
            </Typography>
          </Box>
        </Box>

        <Typography
          variant="h6"
          sx={{
            mt: '16px',
            mb: '8px',
            fontWeight: 'bold',
            fontSize: '20px',
            [theme.breakpoints.down('md')]: {
              mt: '20px',
            },
          }}
        >
          Geschäftszeiten
        </Typography>

        <Typography sx={{ lineHeight: '20px' }}>
          Mo - Do: 08:00 bis 17:00 Uhr
          <br />
          Fr: 08:00 bis 16:00 Uhr
        </Typography>
      </Box>

      <Box
        sx={{
          width: '30%',
          minWidth: '240px',
          [theme.breakpoints.down('md')]: {
            mt: '20px',
            width: '100%',
          },
        }}
      >
        <Typography
          variant="h6"
          sx={{
            mb: '8px',
            fontWeight: 'bold',
            fontSize: '20px',
          }}
        >
          Rechtliches
        </Typography>

        <Typography>
          <Link to="/impressum" onClick={() => scrollTo(0, 0)}>
            Impressum
          </Link>
        </Typography>

        <Typography>
          <Link to="/datenschutz" onClick={() => scrollTo(0, 0)}>
            Datenschutzerklärung
          </Link>
        </Typography>

        {pathname === '/' && (
          <Box sx={{ color: '#bbb' }}>
            Graphics designed by{' '}
            <Typography
              component="a"
              target="_blank"
              href="https://www.freepik.com/"
              sx={{ color: 'link.main' }}
            >
              Freepik
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}
